import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  IndianRupee,
  CheckCircle2,
  XCircle,
  Clock,
} from "lucide-react";
import Layout from "../../components/Layout";

const RefundDetailsPage: React.FC = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const refund = state;
  console.log("hson", JSON.stringify(refund, null, 2));
  const formatCurrency = (amount: number) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    }).format(amount);

  if (!refund) {
    return (
      <Layout>
        <div className="p-6 text-center text-gray-500">
          No refund data found.
        </div>
      </Layout>
    );
  }

  const statusIcons: any = {
    Approved: <CheckCircle2 className="text-green-500" size={22} />,
    Pending: <Clock className="text-yellow-500" size={22} />,
    Rejected: <XCircle className="text-red-500" size={22} />,
  };

  return (
    <Layout>
      <div className="p-6 bg-gray-50 dark:bg-gray-900 min-h-screen">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-blue-600 hover:text-blue-800 mb-6"
        >
          <ArrowLeft size={20} /> Back to Refunds
        </button>

        <div className="max-w-2xl mx-auto bg-white dark:bg-gray-800 shadow-md rounded-2xl p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100">
              Refund Details
            </h2>
            <div className="flex items-center gap-2">
              {statusIcons[refund.status]}
              <span
                className={`font-medium ${
                  refund.status === "Approved"
                    ? "text-green-600"
                    : refund.status === "Pending"
                    ? "text-yellow-600"
                    : "text-red-600"
                }`}
              >
                {refund.status}
              </span>
            </div>
          </div>

          <div className="space-y-3 text-gray-700 dark:text-gray-200">
            <div className="flex justify-between">
              <span>Refund ID:</span>
              <strong>{refund.id}</strong>
            </div>
            <div className="flex justify-between">
              <span>Order ID:</span>
              <strong>{refund.orderId}</strong>
            </div>
            <div className="flex justify-between">
              <span>Customer:</span>
              <strong>{refund.customer}</strong>
            </div>
            <div className="flex justify-between">
              <span>Amount:</span>
              <strong className="flex items-center gap-1 text-green-600">
                <IndianRupee size={16} />
                {formatCurrency(refund.amount)}
              </strong>
            </div>
            <div className="flex justify-between">
              <span>Reason:</span>
              <strong>{refund.reason}</strong>
            </div>
            <div className="flex justify-between">
              <span>Payment Mode:</span>
              <strong>{refund.mode}</strong>
            </div>
            <div className="flex justify-between">
              <span>Transaction Reference:</span>
              <strong>{refund.reference}</strong>
            </div>
            <div className="flex justify-between">
              <span>Processed By:</span>
              <strong>{refund.processedBy}</strong>
            </div>
            <div className="flex justify-between">
              <span>Date:</span>
              <strong>
                {new Date(refund.date).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </strong>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RefundDetailsPage;
